import { newrelic } from './newrelic';
import { TICPaymentFormValuesAddCard } from '../components/InstantCheckoutDrawer/Views/Payments/AddPaymentView/InstantCheckoutAddPayment';
import {
  TCardDetails,
  TCardReference,
  TCardResponseMicroUi,
} from '../constants/orange-pay';

export type TOrangePayInfoResponse = {
  reasonCode: string;
  description: string;
  sessionUuid: string;
};

export type TOrangePaySuccessResponse = {
  expirationMonth?: string;
  expirationYear?: string;
  cardType: string;
  cardBrand: string;
  buyerId?: string;
  reportPaymentMethodCode: string;
  paymentMethodCode: string;
  xrefCardNumber: string;
  posEntryMode: string;
  sessionUuid: string;
  cardReference: TCardReference;
  cardDetails: TCardDetails;
};
export const mapOrangePayResponseToRequestModel = (
  { cardDetails, cardReference, posEntryMode }: TCardResponseMicroUi,
  sessionUuid: string,
): TOrangePaySuccessResponse => {
  const {
    expirationMonth,
    expirationYear,
    reportPaymentMethodCode,
    paymentMethodCode,
    accountNumberXref,
  } = cardDetails;
  const buyerId = cardDetails.authorizedBuyerID;

  const cardBrand =
    OrangePayCardBrandFilterValue[
      cardDetails.reportPaymentMethodCode
    ].toUpperCase();
  const avoidSendExpDate =
    cardBrand === 'HDCOM' || cardBrand === 'HDCON' || Boolean(buyerId);

  return {
    cardType: 'cc',
    cardBrand,
    buyerId,

    expirationMonth: avoidSendExpDate ? undefined : expirationMonth,
    expirationYear: avoidSendExpDate ? undefined : expirationYear,
    xrefCardNumber: accountNumberXref,

    reportPaymentMethodCode,
    paymentMethodCode,
    posEntryMode,
    sessionUuid,

    cardReference,
    cardDetails,
  };
};

export const OrangePayCardBrandFilterValue: Record<string, string> = {
  VI: 'VISA',
  MA: 'MA',
  AX: 'AMEX',
  DS: 'DISC',
  HR: 'HDCOM',
  HC: 'HDCON',
  HP: 'PROX',
  HA: 'PROP',
} as const;

export type TMappedAddPayment = TOrangePaySuccessResponse &
  TICPaymentFormValuesAddCard;

export const mapAddPaymentData = (
  cardData: TOrangePaySuccessResponse,
  values: TICPaymentFormValuesAddCard,
): TMappedAddPayment => {
  const billing = { billingAddress: values.billingAddressID };
  return {
    ...billing,
    ...values,
    ...cardData,
  };
};

export const trackOrangePayNewRelic = (
  name: string,
  response: TOrangePayInfoResponse,
  result = '',
) => {
  const value: { [key: string]: string } = {
    reasonCode: response.reasonCode,
    sessionUuid: response.sessionUuid,
  };
  if (result !== '') {
    value.result = result;
  }
  newrelic.addPageAction(name, value);
};
